'use strict';

module.exports = '0.0.0-5a0352a';
